// extracted by mini-css-extract-plugin
export default {"wrapper":"Statement_wrapper__jY441","disableTextSelection":"Statement_disableTextSelection__6TXqw","buttons":"Statement_buttons__CdUkf"};